import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=b9c84c1a&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c84c1a",
  null
  
)

export default component.exports